const FUNNEL_STAGES = {
  VISITANTES: "Visitante",
  LEADS: "Lead",
  OPPORTUNYTIES: "Oportunidade",
  SALES: "Venda",
};

export default FUNNEL_STAGES;
